import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import router from "../router";
import {
  PreferencesRequest,
  PacsConfigurationRequest
} from "@/core/request";
import UtilFront from "../core/UtilFront";

Vue.use(Vuex);
import {
  createStore
} from "vuex";

import decode from "jwt-decode";

export default new Vuex.Store({
  state: {
    objPref: {},
    token: "",
    data: "",
    preferences: {},
    id: "",
    expired: null,
  },
  mutations: {
    getUser(state, payload) {
      state.token = payload;
      if (payload === "") {
        state.data = "";
      } else {
        state.data = decode(payload);

        state.id = state.data.user.idUser;

        state.preferences = state.data.user.preferences;

        let view = JSON.parse(state.preferences);

        if (localStorage.getItem("preferencias") === null) {
          localStorage.setItem("preferencias", state.preferences);
        }
      }
    },
    setExpired(state, payload) {
      // console.log(payload);
      state.expired = payload;
    },
    setPreferences(state, payload) {
      state.preferences = payload;

      state.preferences = JSON.parse(state.preferences);

      localStorage.setItem("preferencias", JSON.stringify(state.preferences));

      let config = {
        headers: {
          Authorization: state.token,
        },
      };

      let postData = {
        id: state.id,
        preferences: JSON.stringify(state.preferences),
      };

      // axios.post("http://192.168.1.108:8080/riswsdev/app/sc/uspfrvc/uspfr01", postData, config)
      PreferencesRequest.savePreferences(postData, config).then((res) => {
        // console.log(res)
      });
    },
  },
  actions: {
    saveUser({
      commit
    }, payload) {
      localStorage.setItem("token", payload);
      sessionStorage.tokenUser = payload;
      commit("getUser", payload);
    },
    logout({
      commit
    }) {
      commit("getUser", "");
      localStorage.removeItem("token");
      localStorage.clear();
      // window.location.reload();
      router.replace({
        name: "login",
      });
    },
    readToken({
      commit
    }) {
      const token = sessionStorage.tokenUser;
      if (token) {
        commit("getUser", token);
      } else {
        commit("getUser", "");
      }
    },
    validateLicense({
      commit
    }) {
      PacsConfigurationRequest.getLicense().then((response) => {
        let {
          status
        } = response.data.data;
        commit("setExpired", status === 0);

        if (status === 0) {
          // if (status === 0 && (new Vue).$utilFront.getRole() != "SA") {
          if (true) {
            new Vue().$swal.fire({
              title: `<h6>Tu licencia de SUIM ha expirado</h6>`,
              text: "",
              iconColor: "#894545",
              iconHtml: '<i class="mdi mdi-alert"></i>',
              html: `<small>Comunícate con el administrador para más información</small>`,
              confirmButtonText: "Cerrar",
              toast: false,
              imageUrl: window.location.origin + "/img/logo_erillam.a376873d.png",
              imageWidth: "30%",
              confirmButtonColor: "#894545",
              customClass: {
                container: "font-suim",
                popup: "...",
                header: "...",
                title: "font-suim",
              },
              // buttonsStyling: false,
              allowOutsideClick: false,
              allowEscapeKey: false,
              // icon: 'error',
              // background: "rgb(133 15 2)",
              // color: "white",
              // width: "30%",
              // padding: "8%",
            });
          } else {
            new Vue().$swal.fire({
              title: `<h5 style="margin-top:60px">Tu licencia de SUIM ha expirado</h5>`,
              text: "",
              html: ` 
                            <h4 class="mt-5" style="margin-top:20px;text-align: left;"> Comunícate con el administrador para más información. </h4>
                            <h4 style="font-size: 130px; color: #ffffff33; text-align: end;"><i class="mdi mdi-bell-ring-outline"></i></h4>
                          `,
              confirmButtonText: "Cerrar",
              toast: false,
              confirmButtonColor: "#32A965",
              customClass: {
                container: "font-suim",
                popup: "...",
                header: "",
                title: "font-suim",
                confirmButton: "font-suim-confim",
                actions: "margin-left",
              },
              background: "#548C6C",
              color: "#FFFFFF",
              width: "40em",
              buttonsStyling: false,
              allowOutsideClick: false,
              allowEscapeKey: false,
            });
          }
        }
      });
    },
    sPreferences({
      commit
    }, payload) {
      const prf = payload;
      commit("setPreferences", prf);
    },

    validTab() {
      if (process.env.NODE_ENV === 'production') {


        const Swal = require("sweetalert2");
        localStorage.QWERTYUIOP1234567890MDPC = Date.now();
        var localSession = function (e) {
          if (e.key == "QWERTYUIOP1234567890MDPC") {
            // si la página se abre en otro lado!
            localStorage.page_available = Date.now();
          }
          if (e.key == "page_available") {
            // alert("Sin acceso al recurso: Ventana duplicada");
            Swal.fire({
              icon: "error",
              title: "Ventana duplicada",
              text: "El sistema SUIM no admite el uso en múltiples pestañas del navegador, cierre las ventanas no utilizadas.",
            });
            router.replace({
              name: "ventanaDuplicada",
            });
          }
        };
        window.addEventListener("storage", localSession, false);
        if (window.name != sessionStorage.name) {
          router.replace({
            name: "ventanaDuplicada",
          });
        } else if (sessionStorage.name == undefined) {
          router.replace({
            name: "ventanaDuplicada",
          });
        } else {}
      }
      // localStorage.QWERTYUIOP1234567890MDPC = Date.now();
      // var localSession = function(e) {
      //   if (e.key == "QWERTYUIOP1234567890MDPC") {
      //     // si la página se abre en otro lado!
      //     localStorage.page_available = Date.now();
      //   }
      //   if (e.key == "page_available") {
      //     alert("Sin acceso al recurso: Ventana duplicada");
      //     router.replace({
      //       name: "ventanaDuplicada",
      //     });
      //   }
      // };
      // window.addEventListener("storage", localSession, false);
      // if (window.name != sessionStorage.name) {
      //   router.replace({
      //     name: "ventanaDuplicada",
      //   });
      // } else if (sessionStorage.name == undefined) {
      //   router.replace({
      //     name: "ventanaDuplicada",
      //   });
      // } else {
      // }
    },
    unauthorized() {
      router.replace({
        name: "sinAutorizacion",
      });
    },
  },
  getters: {
    isExpired(state) {
      return state.expired;
    },
  },
});